// eslint-disable-next-line import/prefer-default-export
export function formatPrice(value, { currency = 'Ft' } = {}) {
  return `${value?.toLocaleString('hu-HU') || value}${
    currency ? ` ${currency}` : ''
  }`;
}
